const MAX_BUBBLE_MESSAGES = 3;

var Notifier = new (class Notifier extends AbstractModule {

  constructor() {
    super("Notifier");
  }

  /* INIT */

  _initData(data) {
    this._autoInit({
      "sound_active"                : [ data.widget.sound_active, false ],
      "_title_interval"             : [ null, null ],
      "_title_chaging"              : [ null, false ],
      "_title_chaging_text"         : [ null, "" ],
      "_favicon_counter_displayed"  : [ null, false ],
      "_button_counter_displayed"   : [ null, false ],
      "_messages_in_bubble"         : [ null, [] ],
      "_messages_in_buffer"         : [ null, [] ]
    });
  }

  _initAfterWidget() {
    if (this.app._sound_active) {
      this._initAudio();
    }
    this._initFavicon();
    this._initEventHandlers();
  }

  _initEventHandlers() {
    Dom.on('tab-focus', () => { this._resetTabNotification(); });
    Dom.on('open', () => { this._resetClosedNotification(); });
    Conversations.when('ready', () => { this._syncUnread(); });
  }

  _initAudio() {
    let audioElement = document.createElement('audio');
    let soundExtension;
    if (audioElement.canPlayType && audioElement.canPlayType('audio/mpeg;').replace(/no/, ''))
      soundExtension                = 'mp3';
    else
      soundExtension                = 'ogg';
    this._message_audio_ring_new  = new Audio(this.app._cdn_url + '/sounds/new.' + soundExtension);
    this._message_audio_ring_sent = new Audio(this.app._cdn_url + '/sounds/send.' + soundExtension);
  }

  _initFavicon() {
    this.favicon = null;
    if (Platform.name != "IE" && this.app.favicon_counter !== false) {
      try {
        this.favicon = new Favico({
          bgColor: '#fc576b',
          animation:'none',
          win: Dom.parent
        });
      } catch(e) {}
    }
  }

  /* PUBLIC */

  get unread_messages() {
    let total = 0;
    Conversations.forEach(conversation => {
      total += conversation.unread_messages;
    });
    return total;
  }

  notify(message) {
    let silent = false
    if (message.trigger_id) {
      silent = Triggers.get(message.trigger_id).disable_sound
    }
    if (message.fromVisitor()) this._sentRing();
    else if(!silent) this._ring();

    if (!message.fromVisitor()) {
      this._incrementUnread(message);
    }
  }

  displayBubble() {
    return this._displayBubble.apply(this, arguments)
  }

  updateBubble(message) {
    const messageInBubble = this._messages_in_bubble.find(msg => msg === message);
    
    if (messageInBubble && Dom.get('message').isReady()) {
      const bubbleElement = this._findInBubble(message);
      
      if (bubbleElement) {
        const contentElement = bubbleElement.querySelector('.slaask-message-text-content');
        if (contentElement) {
          const plainText = Conversations.getMessageContent(message, 1);
          contentElement.innerHTML = plainText;
          this._updateBubbleSize();
        }
      }
    }
  }

  removeAllBubbles() {
    return this._removeAllBubbles.apply(this, arguments)
  }

  /* LOCAL STORAGE & BACKEND SYNCHRONIZATION */

  _setLastMessageAsReadFor(conversation) {
    if (conversation.id) {
      let lastMessage = conversation.getLastMessage()

      if (lastMessage) {
        let lastSavedRead = Utils.localStorage(`last-read-for-conv-${conversation.id}`)
        if (!lastSavedRead || lastSavedRead != lastMessage.id) {
          Utils.localStorage(`last-read-for-conv-${conversation.id}`, lastMessage.id)
          Ajax.call('/api/read', { conversation_id: conversation.id, key: this.app._api_key, guest_id: this.app._guest_id });
          conversation.markAllMessagedAsRead()
        }
      }
    }
  }

  _syncUnread() {
    Conversations.forEach(conversation => {
      if (conversation.isOpen()) {
        const unreadMessages = conversation.unreadMessages()
        const unreadCount = unreadMessages.length
        if (unreadCount > 0) {
          const lastUnreadMessage = unreadMessages[unreadMessages.length - 1]
          conversation.unread_messages = unreadCount;
          this._resetUnreadOnConversationOpen(conversation);
          this._notifyInWidget(conversation);
          this._notifyClosed(lastUnreadMessage, { bubble: false });
          this._notifyTab(lastUnreadMessage);
        }
      }
    })
  }

  /* HANDLING UNREAD */

  _incrementUnread(message) {
    let conversation = Conversations.get(message.conv_id);
    if (this._shouldNotifyInWidget(conversation)) {
      if (conversation.unread_messages == 0) {
        this._resetUnreadOnConversationOpen(conversation);
      }
      conversation.unread_messages++;
      this._notifyInWidget(conversation);
      this._notifyClosed(message);
      this._notifyTab(message);
    } else {
      this._setLastMessageAsReadFor(conversation)
    }
  }

  _resetUnreadOnConversationOpen(conversation) {
    Dom.get('widget').when('ready').then(() => {
      let onActive = () => {
        if (!this._shouldNotifyInWidget(conversation)) {
          this._resetUnread(conversation);
          Views.getByName('conversation').off('active', onActive);
          Dom.off('tab-focus', onActive);
        }
      };
      Views.getByName('conversation').on('active', onActive);
      Dom.on('tab-focus', onActive);
    });
  }

  _resetUnread(conversation) {
    conversation.unread_messages = 0;
    this._resetInWidgetNotification(conversation);
    this._updateButtonCounter();
    this._setLastMessageAsReadFor(conversation)
  }

  /* NOTIFY GLOBAL */

  _notifyInWidget(conversation) {
    this._showConversationUnread(conversation);
  }

  /**
   * @param {Message} message
   * @param {{ counter?: boolean, bubble?: boolean }} options
   */
  _notifyClosed(message, options = {}) {
    if (this._shouldNotifyClosed()) {
      if (!options || options.counter !== false) this._updateButtonCounter();
      if (!options || options.bubble !== false) this._displayBubble(message);
    }
  }

  _notifyTab(message) {
    if (this._shouldNotifyTab()) {
      this._showTitleChanging(message.name);
      this._showFaviconCounter();
      this._updateFaviconCounter();
    }
  }

  /* RESET GLOBAL */

  _resetInWidgetNotification(conversation) {
    this._resetConversationUnread(conversation);
  }

  _resetClosedNotification() {
    this._resetButtonCounter();
    this._hideBubble();
  }

  _resetTabNotification() {
    this._resetTitleChanging();
    this._resetFaviconCounter();
  }

  /* SHOULD NOTIFY? */

  _shouldNotifyInWidget(conversation) {
    return !Dom.widget_displayed
      || Views.current.name != 'conversation'
      || Conversations.current != conversation
      || !Dom.parent.document.hasFocus();
  }

  _shouldNotifyClosed() {
    return /*!Dom.widget_displayed && */!Dom.hide_slaask_button;
  }

  _shouldNotifyTab() {
    return !Dom.parent.document.hasFocus();
  }

  /* SHOW UNREAD FEEDBACK */

  _showConversationUnread(conversation) {
    let notifElements = Dom.findAll('widget', '.slaask-widget-convpage-unread[data-id="' + conversation.id + '"]');
    Utils.forEach(notifElements, (notifElement) => {
      notifElement.setAttribute('data-unread', Math.min(conversation.unread_messages, 10));
    });
  }

  _showTitleChanging(from) {
    if (this._shouldNotifyTab()) {
      this._updateTitleChanging(from);

      if (!this._title_changing) {
        let blink = true;
        this._previous_title = document.title;
        this._title_interval = setInterval(() => {
          if (blink)
            document.title = this._title_chaging_text;
          else
            document.title = this._previous_title;
          blink = !blink;
        }, 2000);
        this._title_changing = true;
      }
    }
  }

  _showFaviconCounter() {
    if (this.favicon && !this._favicon_counter_displayed && this._shouldNotifyTab()) {
      try {
        if (this.unread_messages == 0) {
          this._resetFaviconCounter();
        } else {
          this._favicon_counter_displayed = true;
          this._updateFaviconCounter();
        }
      } catch(e) {
        Utils.warn(e);
      }
    }
  }

  _showButtonImage(url) {
    if (Dom.get('button').isReady()) {
      if (this.app._full_width_button)
        Dom.findById('button', 'slaask-button-image').style['background-image'] = 'url("' + url + '")';
    }
  }

  /* UPDATE UNREAD FEEDBACK */

  _updateUnreadMessages(conversation, n) {
    conversation.unread_messages = n;
  }

  _updateTitleChanging(from) {
    let from_title = from || this.app._support_name;
    this._title_chaging_text = from_title + " " + Wording.title_changing_text;
  }

  _updateFaviconCounter() {
    if (this.favicon && this._favicon_counter_displayed) {
      this.favicon.badge(this.unread_messages);
    }
  }

  _updateButtonCounter() {
    if (this._shouldNotifyClosed()) {
      Dom.get('button').when('ready').then(() => {
        Utils.uniqueTimeout('notifier-button-counter', () => {
          if (this.unread_messages == 0) {
            this._resetButtonCounter();
            Dom.get('button').element.removeAttribute('data-messages-counter');
          }
          else {
            let lis = Dom.findAll('button', '#messages-counter li');
            let unread = this.unread_messages;
            Dom.get('button').element.setAttribute('data-messages-counter', unread);
            lis[0].innerHTML = (unread) || "";
            lis[1].innerHTML = unread;
            Dom.addClass('button', '#messages-counter', 'update-count');

            this._setTimeout(() => {
              lis[0].innerHTML = unread
            }, 150);

            this._setTimeout(() => {
              Dom.removeClass('button', '#messages-counter', 'update-count');
            }, 200);

            this._setTimeout(() => {
              lis[1].innerHTML = unread + 1
            }, 230);

            Dom.removeClass('button', '#messages-counter', 'slaask-hidden');
          }
        }, 20);
      });
    }
  }

  /* RESET UNREAD FEEDBACK */

  _resetConversationUnread(conversation) {
    let notifElements = Dom.findAll('widget', '.slaask-widget-convpage-unread[data-id="' + conversation.id + '"]');
    Utils.forEach(notifElements, (notifElement) => {
      notifElement.removeAttribute('data-unread');
    });
  }

  _resetTitleChanging() {
    if (this._title_changing) {
      clearInterval(this._title_interval);
      document.title = this._previous_title;
      this._title_changing = false;
    }
  }

  _resetFaviconCounter() {
    if (this.favicon) {
      this._favicon_counter_displayed = false;
      this.favicon.reset();
    }
  }

  _resetButtonCounter() {
    if (Dom.get('button').isReady()) {
      Dom.addClass('button', '#messages-counter', 'slaask-hidden');
    }
  }

  _resetButtonImage() {
    if (Dom.get('button').isReady()) {
      if (this.app._full_width_button)
        Dom.findById('button', 'slaask-button-image').style['background-image'] = 'url("' + this.app._message_displayed_image + '")'
    }
  }

  /* RING */

  _ring() {
    if(this.app._sound_active) {
      try {
        let promise = this._message_audio_ring_new.play();
        if (promise)
          promise.catch(error => {
            Utils.warn(error);
          });
      } catch (e) {
        Utils.warn(e);
      }
    }
  }

  _sentRing() {
    if(this.app._sound_active) {
      try {
        let promise = this._message_audio_ring_sent.play();
        if (promise)
          promise.catch(error => {
            Utils.warn(error);
          });
      } catch (e) {
        Utils.warn(e);
      }
    }
  }

  /* BUBBLE */

  _initBubbleEventHandlers(message) {
    let clickOnMessage = () => {
      if (!Dom.hasClass('message', 'slaask-hidden')) {
        if(Triggers._message_trigger) {
          Triggers.triggerClicked(Triggers.get(message.trigger_id))
        }
        Conversations.userCommittedToNewConversation();
        Views.jumpToViewByName('conversation', message.conversation.id);
        Dom.showWidget({ by: 'message_click' })
        this.removeAllBubbles()
      }
    };

    Dom.get('message').when('ready', () => {
      this._registerEvent(
        this._findInBubble(message).querySelector('.slaask-message-header-cross'),
        'click',
        (event) => {
          event.stopPropagation();
          this.removeAllBubbles();
        });
      this._findInBubble(message).addEventListener("click", clickOnMessage);
      this._findInBubble(message).querySelector('.message-read-more').addEventListener("click", clickOnMessage);
    });
  }

  _findInBubble(message) {
    try {
      return Dom.find('message', '#slaask-message-bubble-' + message.id);
    } catch (e) {
      return null;
    }
  }

  /**
   * displayBubble
   * @param  {Message} message
   * @param  {number}  time     0 => forever
   */
  async _displayBubble(message, time = null) {
    await Promise.all([
      Dom.get('message').buildIfNeeded(),
      Dom.get('gradient').buildIfNeeded()
    ]);

    if (!Views.widget_open && !Dom.hide_slaask_button) {
      if (this._messages_in_bubble.length >= MAX_BUBBLE_MESSAGES) {
        this._messages_in_buffer.push(message);
      } else {
        if (this._messages_in_bubble.length > 0 && this._messages_in_bubble[0].conversation.id != message.conversation.id) {
          this.removeAllBubbles();
        }

        this._messages_in_bubble.push(message);
        let plainText = Conversations.getMessageContent(message, 1);

        Dom.removeClass('message', 'slaask-hidden')
        Dom.get('message').addMessage(message);

        this._findInBubble(message).querySelector('.slaask-message-text-content').insertAdjacentHTML( 'beforeend', plainText);
        this._findInBubble(message).querySelector('.slaask-message-text-title').insertAdjacentHTML( 'beforeend', message.name);
        this._initBubbleEventHandlers(message);

        var bubbleImages = Dom.findAll('message', '.slaask-message-text-content img')
        Utils.forEach(bubbleImages, img => {
          img.addEventListener('load', () => {
            this._updateBubbleSize();
          })
        });

        this._showButtonImage(message.image);

        this._updateBubbleSize();

        if (this.app._mini_widget && (this.app._x_offset === 0 && this.app._y_offset === 0)) Dom.removeClass('gradient', 'slaask-hidden');

        if (message.trigger_id && time == null) {
          const trigger = Triggers.get(message.trigger_id);
          if (trigger && Utils.exists(trigger.duration)) {
            time = trigger.duration;
          }
        }
        if (time == null) {
          time = this._calculateDisplayTime(this._messages_in_bubble[0])
        }

        if (time > 0 && time != Infinity) Utils.uniqueTimeout('closed-message',() => {
          this._hideBubble(this._messages_in_bubble[0]);
          this._displayBubbleFromBuffer();
        }, time);
        else Utils.clearTimeout('closed-message');
      }
    }
  }

  _displayBubbleFromBuffer() {
    if (this._messages_in_buffer.length > 0 && this._messages_in_bubble.length < MAX_BUBBLE_MESSAGES) {
      this.displayBubble(this._messages_in_buffer.shift())
    }
  }


  _hideBubble(message = null) {
    let time = null
    if (Dom.get('message').isReady()) {
      if (this.app._mini_widget) Dom.addClass('gradient', 'slaask-hidden');
      Dom.addClass('message', '#message-read-more', 'slaask-hidden');
      if (message !== null) {
        const index = this._messages_in_bubble.indexOf(message)
        let node = this._findInBubble(message)
        if(node)  node.parentNode.removeChild(node);
        this._messages_in_bubble.splice(index, 1)

        time = this._calculateDisplayTime(this._messages_in_bubble[0])
        Utils.uniqueTimeout('closed-message',() => {
          this._hideBubble(this._messages_in_bubble[0]);
          this._displayBubbleFromBuffer();
        }, time);
      } else {
        Dom.addClass('message', 'slaask-hidden');
      }
    }
    if (this._messages_in_bubble.length == 0){
        this._resetButtonImage();
        this._hideBubbleList()
        Utils.clearTimeout('closed-message');
    }
    this._updateBubbleSize()
  }

  _hideBubbleList() {
    if(this._messages_in_bubble.length == 0) {
      Dom.addClass('message', 'slaask-hidden')
    }
  }

  _removeAllBubbles() {
    this._messages_in_buffer = []
    for (let i = 0; i < MAX_BUBBLE_MESSAGES && this._messages_in_bubble[0]; i++) {
      this._hideBubble(this._messages_in_bubble[0])
    }
    this._resetButtonImage()
  }

  _updateBubbleSize() {
    let wrapperSize = 0;
    let lastSender = null;

    this._messages_in_bubble.forEach( (message) => {
      if (this._findInBubble(message)) {
        if (message.name === lastSender) {
          this._findInBubble(message).querySelector('.slaask-message-header-wrapper').classList.add('slaask-hidden')
          this._findInBubble(message).classList.add('slaask-no-header')
        } else {
          this._findInBubble(message).querySelector('.slaask-message-header-wrapper').classList.remove('slaask-hidden')
          this._findInBubble(message).classList.remove('slaask-no-header')
        }
        lastSender = message.name

        let textContent = this._findInBubble(message).querySelector('#slaask-message-text-content');
        let maxSize = parseFloat(textContent.ownerDocument.defaultView.getComputedStyle(textContent)['max-height']);

        // Fake size
        Dom.get('message').fakeSize("current", 0);
        Dom.removeClass('message', '#slaask-message-bubble-' + message.id,'slaask-hidden');
        textContent.style['max-height'] = '500px';

        Dom.get('message').realSize();

        // Toggle read-more
        if (maxSize && this._findInBubble(message).querySelector('#slaask-message-text-content').clientHeight > maxSize) {
          Dom.removeClass('message', '#slaask-message-bubble-' + message.id + ' #message-read-more', 'slaask-hidden');
        }
        else
          Dom.addClass('message', '#slaask-message-bubble-' + message.id + '#message-read-more', 'slaask-hidden');

        // Restore size
        textContent.style['max-height'] = maxSize + 'px';

        wrapperSize += maxSize + 10
      }
    })
    if (this._messages_in_bubble.length == MAX_BUBBLE_MESSAGES) {
      Dom.get('message')._element.style['max-height'] = wrapperSize
    }
  }

  _calculateDisplayTime(message) {
    try {
      let plainText = Conversations.getMessageContent(message, 1);
      return Utils.exists(message.bubble_display_time) ? parseInt(message.bubble_display_time) : Math.min(5000 + 50 * this.app._askTechParser.parsePlain(plainText).length, 20000);
    } catch (e) {
      return null;
    }
  }
});
